import { Stack } from 'expo-router';
import { useUnistyles } from 'react-native-unistyles';
import usePlatform from '@/utils/hooks/usePlatform';

const LoginNavigator = ({initalRouteName}) => {
    const { theme: { colors } } = useUnistyles();
    const { isWeb } = usePlatform();

    return (
        <Stack initialRouteName={initalRouteName} screenOptions={{
            headerTransparent: true,
            headerTintColor: colors.text,
            headerTitle: "",
            headerBackTitleVisible: false,
            headerStyle:{
                height:100
            },
        }}>
            <Stack.Screen 
                name="login" 
                options={{
                    headerShown: false
                }}
            />

            <Stack.Screen 
                name="select-organization" 
                options={{
                    headerTitle: "",
                    headerLeft: () => null,
                }}
            />
            
            <Stack.Screen 
                name="account/recover" 
                options={{
                    headerShown: !isWeb,
                    headerBackTitleVisible: true
                }}
            />
            
            <Stack.Screen 
                name="account/reset-password" 
                options={{
                    headerShown: !isWeb,
                    headerBackTitleVisible: true
                }}
            />
            <Stack.Screen 
                name="account/create" 
                options={{headerShown: !isWeb, headerTintColor: colors.text, headerBackTitleVisible: true}}
            />
        </Stack>
    )
}


export default LoginNavigator